import React, { useState } from 'react';

export default function Logo({ size = 36, alt = 'Talent Link', className = '' }) {
  // Include the exact filename as it exists in `public/` (case-sensitive on Linux hosts)
  const paths = ['/TalentLinkLogo.png', '/talentlinklogo.png', '/talent-link-logo.png', '/Talent Link Logo.png', '/Talent%20Link%20Logo.png', '/logo.png'];
  const [index, setIndex] = useState(0);

  const inlineSVG = `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}'>
      <rect width='100%' height='100%' fill='#105090' rx='10' />
      <text x='50%' y='55%' font-size='18' font-family='Arial' fill='white' text-anchor='middle' alignment-baseline='middle'>TL</text>
    </svg>`
  )}`;

  function handleError(e) {
    const next = index + 1;
    if (next < paths.length) {
      setIndex(next);
      e.target.src = paths[next];
    } else {
      e.target.src = inlineSVG;
    }
  }

  return (
    <img
      src={paths[index]}
      alt={alt}
      className={className}
      width={size}
      height={size}
      onError={handleError}
      style={{ width: size, height: size, borderRadius: 8, objectFit: 'cover' }}
    />
  );
}
